import React, { useEffect, useState } from "react";
import { returnServicosFinanceiros } from "./functions";

import { LoadingButton } from "../loadingButtom";

import { AiOutlineReload } from "react-icons/ai";
import { MultiSelect } from 'primereact/multiselect';

interface CadastroServicosProps {
  idsServicosFinanceiros: number[];
  setIdsServicosFinanceiros: React.Dispatch<
    React.SetStateAction<Array<number>>
  >;
}

interface ServiçoProps {
  id: number,
  nome: string,
  descricao: string,
  ativo: boolean
}


export const CadastroServicos = ({
  idsServicosFinanceiros,
  setIdsServicosFinanceiros,
}: CadastroServicosProps) => {
  const [servicos, setServicos] = useState<Array<ServiçoProps>>([]);
  const [loadingServicosFinanceiros, setLoadingServicosFinanceiros] = useState<boolean>(false);
  const [erroServicos, setErroServicos] = useState<boolean>(false);
  const [reload, setReload] = useState<boolean>(false)


  useEffect(() => {
    returnServicosFinanceiros(setLoadingServicosFinanceiros, setServicos, setErroServicos);
  }, [reload]);

  function handleSelect(idsSelecionados: number[]) {
    setIdsServicosFinanceiros(idsSelecionados);
  }

  const servicosDisponiveis = servicos.filter((servico) => servico.nome === "Private");
  const servicosEscolhidos = servicosDisponiveis.filter((servico) =>
    idsServicosFinanceiros.includes(servico.id)
  );

  return (
    <div>
      <div className="Area_SelecaoServico">
        <div className="cadastro-servicos-picker">
          <label id="cadastro-servicos-label" className="TextoSubTitulo" htmlFor="cadastro-servicos-select">
            Escolha o seu tipo de serviço ideal
          </label>
          {loadingServicosFinanceiros ? <LoadingButton /> : servicos.length > 0 &&
            <MultiSelect
              inputId="cadastro-servicos-select"
              ariaLabelledBy="cadastro-servicos-label"
              className="cadastro-servicos-select"
              panelClassName="cadastro-servicos-panel"
              value={idsServicosFinanceiros}
              options={servicosDisponiveis}
              onChange={(e) => handleSelect(e.value || [])}
              dataKey="id"
              optionLabel="nome"
              optionValue="id"
              placeholder="Escolha seu serviço"
              display="chip"
              maxSelectedLabels={3}
              selectedItemsLabel="{0} serviços selecionados"
              showClear
              showSelectAll={false}
            />
          }
        </div>
        {erroServicos && <>
          <p>Ocorreu um erro. Por favor tente novamente.</p>
          <AiOutlineReload
            onClick={() => setReload(!reload)}
          />
        </>
        }
        <div className="cadastro-servicos-resumo">
          <h3 className="servicosSelecionados">Serviços Selecionados</h3>
          {servicosEscolhidos.length > 0 ?
            servicosEscolhidos.map((item) => {
              return <div key={item.id} className="cadastro-servico-selecionado">
                <h5 className="TextoSubTitulo">{item.nome}</h5>
                <p className="descricaoServico">{item.descricao}</p>
              </div>
            })
            :
            <p className="descricaoServico">Nenhum serviço selecionado</p>
          }
        </div>
      </div>
    </div>
  );
};
